import { Box, Slider, Stack, Typography } from '@mui/material';
import NumberInput from '~/components/Inputs/NumberInput';
import { mmToCm } from '~/utils/units';
import { MAX_MARGIN_MM, marginStepCm } from './marginRange';

interface SymmetricMarginControlsProps {
    margin: number;
    onMarginChange: (value: number) => void;
    /** See {@link NumberInput}'s `onValidityChange`. */
    onValidityChange: (isValid: boolean) => void;
}

const inputStyle = {
    textAlign: 'center' as const,
    width: '50px',
    fontSize: 13,
    paddingTop: 5,
    paddingBottom: 4,
};

export default function SymmetricMarginControls({
    margin,
    onMarginChange,
    onValidityChange,
}: SymmetricMarginControlsProps) {
    const sliderMax = mmToCm(MAX_MARGIN_MM);

    const handleChange = (value: number | null) => {
        onMarginChange(value ?? 0);
    };

    return (
        <Stack direction="row" alignItems="center" spacing={2}>
            <Box flex={1} px={1}>
                <Slider
                    value={margin}
                    onChange={(_, value) => onMarginChange(value as number)}
                    min={0}
                    max={sliderMax}
                    step={0.05}
                    valueLabelDisplay="auto"
                    valueLabelFormat={(value) => `${value.toFixed(2)} cm`}
                    aria-label="Margin"
                />
            </Box>
            <Stack direction="row" alignItems="center" spacing={1}>
                <NumberInput
                    value={margin}
                    onChange={handleChange}
                    onValidityChange={onValidityChange}
                    min={0}
                    max={sliderMax}
                    step={marginStepCm}
                    snapToStep
                    precision={2}
                    inputProps={{
                        style: inputStyle,
                        'aria-label': 'Margin',
                    }}
                    commitOnChange
                    tooltipPlacement="left"
                />
                <Typography fontSize={12} color="text.secondary">
                    cm
                </Typography>
            </Stack>
        </Stack>
    );
}
